import { render, staticRenderFns } from "./bottomBtns.vue?vue&type=template&id=48f4cc10"
import script from "./bottomBtns.vue?vue&type=script&lang=js"
export * from "./bottomBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports